/** Future backend base path */
export enum ContentPageEndpoints {
  CONTENT_PAGES = '/admin/content-pages',
}

export type ContentPageType = 'blog';

export const CONTENT_PAGE_TYPES: ContentPageType[] = ['blog'];

/**
 * Block payload from API/editor.
 * - Object-root schemas: plain object
 * - Array-root schemas (e.g. gallery): array of item objects
 */
export interface IContentBlockInstance {
  id: string;
  type: string;
  /** Object or array depending on schema root `type` */
  data: unknown;
}

export interface IContentPage {
  id: string;
  pageType: ContentPageType;
  title: string;
  slug: string;
  tags: string[];
  blocks: IContentBlockInstance[];
  /** Blog API: top-level flags */
  published?: boolean;
  isDraft?: boolean;
  isPinned?: boolean;
  coverImage?: string | null;
  publishedAt?: string | null;
  categoryId?: string | null;
  /** Blog category (GET /blog/categories) */
  blogCategoryId?: string | null;
  /** Blog API: per-locale meta + blocks */
  localeMeta?: Record<string, { name: string; slug: string; description: string }>;
  localeBlocks?: Record<string, IContentBlockInstance[]>;
}
